import { useHistory } from "react-router-dom";

import InfoIcon from "../../../../Icon-SVG/InfoIcon";

const UrlsFileHash = (props) => {
  const fileHash = props?.row?.original?.file_hash || "-";
  const reportID = props?.row?.original?.report_id || "";

  const history = useHistory();

  const navigationHandler = (e) => {
    e.stopPropagation();
    history.push(`/analysis-reports?data=${reportID}`);
  };

  return (
    <div className="ioc-file-hash">
      <span className="ioc-file-hash__value" title={fileHash}>
        {fileHash}
      </span>
      {reportID && (
        <button
          type="button"
          className="ioc-file-hash__info"
          title="Show related report"
          aria-label="Show related report"
          onClick={navigationHandler}>
          <InfoIcon width={12} height={12} color="var(--details-text-color)" />
        </button>
      )}
    </div>
  );
};

export default UrlsFileHash;
